module.exports = __webpack_public_path__ + "img/cynergy-logo-black.bd477533.png";